module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mentor-calendar"
  }, [(_vm.eventsLoaded) ? _c('div', {
    staticClass: "calendar-wrapper"
  }, [_c('full-calendar', {
    ref: "calendar",
    attrs: {
      "self": _vm.self,
      "config": _vm.config,
      "header": _vm.calendarHeader,
      "events": _vm.calendarEvents
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "schedule-modal",
    attrs: {
      "id": "schedule-modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "id": "hide-schedule-modal"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Add Production Schedule Span")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "schedule-projects"
    }
  }, [_c('option', {
    attrs: {
      "default": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Project")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      style: ({
        backgroundColor: project.color
      }),
      domProps: {
        "value": project.id
      }
    }, [_vm._v(_vm._s(project.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "id": "feed"
    },
    domProps: {
      "value": _vm.feed
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "schedule-start"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "schedule-end"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "id": "add-schedule"
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), (_vm.meetingToEdit) ? _c('div', {
    staticClass: "edit-modal",
    on: {
      "click": function($event) {
        _vm.meetingToEdit = null
      }
    }
  }, [_c('form', {
    staticClass: "text-center",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h3', [_vm._v("Edit Live Session")]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v("This live session is scheduled for " + _vm._s(_vm._f("longDate")(_vm.meetingToEdit.start)))]), _vm._v(" "), _c('ul', {
    staticClass: "buttons"
  }, [_c('li', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.meetingToEdit.reschedule = !_vm.meetingToEdit.reschedule
      }
    }
  }, [_vm._v("\n                        Reschedule\n                        ")])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-success delete",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteMeeting()
      }
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), (_vm.meetingToEdit.reschedule) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meetingToEdit.participants),
      expression: "meetingToEdit.participants"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.meetingToEdit.participants = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.students), function(student) {
    return _c('option', {
      domProps: {
        "value": student.id
      }
    }, [_vm._v(_vm._s(student.firstName) + " " + _vm._s(student.lastName))])
  })), _vm._v(" "), _c('date-picker', {
    attrs: {
      "date": _vm.meetingToEdit.date,
      "option": _vm.dateOptions
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateMeeting()
      }
    }
  }, [_vm._v("Save")])], 1) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Name",
      "id": "schedule-name"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-308edba9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/MentorCalendar.vue
// module id = 2010
// module chunks = 2